/* eslint-disable no-unused-vars */
import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';

const ContactForm = () => {
  const form = useRef();
  const fileInputRef = useRef(null);
  const [inputs,setInputs] = React.useState({});
  const [selectedValue,setSelectedValue] = React.useState('');
  const [selectTitleFirst,setSelectTitleFirst] = React.useState('');
  const [selectTitleSecond,setSelectTitleSecond] = React.useState('');

  const [fName1Val,setFName1Val] = React.useState('');
  const [pfName1Val,setPfName1Val] = React.useState('');
  const [lName1Val,setLName1Val] = React.useState('');
  const [phone1Val,setPhone1Val] = React.useState('');
  const [email1Val,setEmail1Val] = React.useState('');
  const [house1Val,setHouse1Val] = React.useState('');
  const [appt1Val,setAppt1Val] = React.useState('');
  const [city1Val,setCity1Val] = React.useState('');
  const [state1Val,setState1Val] = React.useState('');
  const [zip1Val,setZip1Val] = React.useState('');
  const [cc1Val,setCC1Val] = React.useState('');

  const [fName2Val,setFName2Val] = React.useState('');
  const [pfName2Val,setPfName2Val] = React.useState('');
  const [lName2Val,setLName2Val] = React.useState('');
  const [phone2Val,setPhone2Val] = React.useState('');
  const [email2Val,setEmail2Val] = React.useState('');
  const [house2Val,setHouse2Val] = React.useState('');
  const [appt2Val,setAppt2Val] = React.useState('');
  const [city2Val,setCity2Val] = React.useState('');
  const [state2Val,setState2Val] = React.useState('');
  const [zip2Val,setZip2Val] = React.useState('');

  
  const [imageSrc, setImageSrc] = React.useState(null);
  

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Create a temporary URL for the image preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadButtonClick = () => {
    // Programmatically trigger the hidden file input click
    fileInputRef.current.click();
  };










  const selectChange = (e) => {
    setSelectedValue(e.target.value);
  }

  const selectTitleFirstChange = (e) => {
    setSelectTitleFirst(e.target.value);
  }

  const selectTitleSecondChange = (e) => {
    setSelectTitleSecond(e.target.value);
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setInputs(values => ({...values, [name]: value}))
  } 

  const sendEmail = (e) => {

    e.preventDefault();
    emailjs.sendForm('service_yb740q3', 'template_1r1f35a', form.current, {
        publicKey: 'DAwBmAa9R4OjrDBoy',
      })
      .then(
        () => {
          alert('Email sent successfully!');
          // Optional: reload the page or reset the form
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Failed to send email.');
        }
      );
  };

  return (
    
    <form ref={form} name="member_form" onSubmit={sendEmail} className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"center",background:'#eceff3f6',width:"auto", }}>
      <br></br>
      <br></br>
      <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>
        Below you will find our Membership form.<br></br>
        This form is can be used for the following:<br></br> 
        By a sponsor to apply on behalf of a prospective member couple<br></br>
        By an existing member couple to renew membership<br></br>
        By an existing member couple to update information that has changed<br></br>


      </div>
      <br></br>
      <br></br>
      <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>
        Please note that the information gathered here is not stored on this server and will be e-mailed to the Board of Kermis Club.<br></br>
        If you are uncomfortable using an electronic form, a physical paper form will be available at the Kermis Dance Club events.<br/>
        The paper form can be given to any Board member at any event or can be mailed to the address provided on the paper form itself.<br/>
      </div>
      <br/>
      <br/>

      <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>
        The information provided below or on the paper form will be inserted into our Club Directory.<br/>
        (If you do not wish to have information published in the Directory, please indicate this using the &quot;DO NOT PUBLISH&quot; checkbox on the form.)<br/>
        Your information will never by published on the website unless specifically requested.<br/>
        <br/>
        The order in which the information is provided will be the order in which it is presented in the Club Directory.<br/>
      </div>
      <br/>
      <br/>

      <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>
        <p>If you have any questions, comments or concerns about this form, please use the <a href="../ContactUs">Contact page</a></p>
        </div>
      <br/>
      <br/>
      <hr></hr>
      <br/>
      <br/>
      <label className='blackBodyFontCenterBold'>DO NOT PUBLISH  
        <input 
            type="checkbox" 
            id="nopublish" 
            name="nopublish" 
            style={{ marginLeft: '10px' }} 
            checked={inputs.nopublish} 
            onChange={handleChange}
        />
      </label>
      <br></br>

      <label>
        Please select the use of the form:
        <br></br>
        <select 
          name="topic" 
          required="true" 
          className={`blackBodyFontCenterBold`} 
          value={selectedValue}
          onChange={selectChange}>
            <option value="member_renew">Membership Renewal</option>
            <option value="member_update">Membership information update</option>
            <option value="sponsor_app">Application on behalf of Guest Couple</option>
        </select>
      </label>
      {selectedValue === 'sponsor_app' && (
        <div style={{ marginTop: '10px' }}>
          <label >Sponsor Name:</label>
          <input
            type="text"
            id="sponsorName"
            name="sponsorName"
            style={{ marginLeft: '10px' }}
          />
          <br/>
          <label >Sponsor Email:</label>
          <input
            type="text"
            id="sponsorEmail"
            name="sponsorEmail"
            style={{ marginLeft: '10px' }}
          />
        </div>
        
      )}
      <br/>
<br/>


      <label className='boldFancyHeadFontCenter2'>Member Information to be listed first in Directory:      </label>

        <table style={{marginLeft: "auto",marginRight:"auto",width:"60%"}}>
          <tr>
            <td style={{textAlign:'right',width:'50%'}}>
              <label>
                Title:
              </label>
            </td> 
            <td style={{marginLeft: '10px',textAlign:"left"}}>
              <select 
                name="firstTitle" 
                className={`blackBodyFontCenterBold`} 
                value={selectTitleFirst}
                onChange={selectTitleFirstChange}
                style={{ marginLeft: '10px',width:'50%',alignContent:'right' }}>
                  <option value="Dr.">Dr.</option>
                  <option value="Prof.">Prof.</option>
                  <option value="Ms.">Ms.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Other">Other - Specify with Name</option>
                  <option value="None">No Honorific</option>
                  
              </select>
            </td> 
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>First Name:</label>
          </td> 
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input 
              className={`blackBodyFontCenterBold`} 
              type="text" 
              name="fName1" 
              style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setFName1Val(e.target.value)}
            />
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Preferred First Name:        </label>
          </td> 
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="pfName1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            onChange={e => setPfName1Val(e.target.value)}/>
          </td> 
        </tr>
       <tr>
          <td style={{textAlign:'right',width:'50%'}}>
              <label style={{ marginLeft: '10px'}}>Last Name:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="lName1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            onChange={e => setLName1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px',marginTop:'10px',alignItems:'left'}}>Contact Phone:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="phone1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            onChange={e => setPhone1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Email address:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="email" name="email1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            onChange={e => setEmail1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Name on event badge:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="bName1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              defaultValue={pfName1Val + ' '+ lName1Val}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Street Address:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="house1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setHouse1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Suite/Apt number:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="appt1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setAppt1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>City:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="city1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setCity1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>State:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="state1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setState1Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Zip code:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="zip1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setZip1Val(e.target.value)}/>
          </td>
        </tr>

</table>

     <br></br>
  

       <label className='boldFancyHeadFontCenter2'>Member Information to be listed second in Directory:      </label>
         <table style={{marginLeft: "auto",marginRight:"auto",width:"60%"}}>
          <tr>
            <td style={{textAlign:'right',width:'50%'}}>
              <label>
                Title:
              </label>
            </td> 
            <td style={{marginLeft: '10px',textAlign:"left"}}>
              <select 
                name="secondTitle" 
                className={`blackBodyFontCenterBold`} 
                value={selectTitleSecond}
                onChange={selectTitleSecondChange}
                style={{ marginLeft: '10px',width:'50%',alignContent:'right' }}>
                  <option value="Dr.">Dr.</option>
                  <option value="Prof.">Prof.</option>
                  <option value="Ms.">Ms.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Other">Other - Specify with Name</option>
                  <option value="None">No Honorific</option>
                  
              </select>
            </td> 
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>First Name:</label>
          </td> 
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input 
              className={`blackBodyFontCenterBold`} 
              type="text" 
              name="fName2" 
              style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setFName2Val(e.target.value)}
            />
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Preferred First Name:        </label>
          </td> 
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="pfName2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            onChange={e => setPfName2Val(e.target.value)}/>
          </td> 
        </tr>
       <tr>
          <td style={{textAlign:'right',width:'50%'}}>
              <label style={{ marginLeft: '10px'}}>Last Name:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="lName2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            defaultValue={lName1Val}
            onChange={e => setLName2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px',marginTop:'10px',alignItems:'left'}}>Contact Phone:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="phone2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            defaultValue={phone1Val}
            onChange={e => setPhone2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Email address:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="email" name="email2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            defaultValue={email1Val}
            onChange={e => setEmail2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Name on event badge:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="bName2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              defaultValue={pfName2Val + ' '+ lName2Val}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Street Address:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="house2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              defaultValue={house1Val}
              onChange={e => setHouse2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Suite/Apt number:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="appt2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              defaultValue={appt1Val}
              onChange={e => setAppt2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>City:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="city2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              defaultValue={city1Val}
              onChange={e => setCity2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>State:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="state2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
            defaultValue={state1Val}
              onChange={e => setState2Val(e.target.value)}/>
          </td>
        </tr>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
            <label style={{ marginLeft: '10px'}}>Zip code:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="zip2" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              defaultValue={zip1Val}
              onChange={e => setZip2Val(e.target.value)}/>
          </td>
        </tr>
</table>
<br/>
<br/>
<table>
        <tr>
          <td style={{textAlign:'right',width:'50%'}}>
          <label style={{ marginLeft: '10px'}}>Country Club Affliations:</label>
          </td>
          <td style={{marginLeft: '10px',textAlign:"left"}}>
            <input className={`blackBodyFontCenterBold`} type="text" name="cc1" style={{marginLeft: '10px',marginTop:'10px',width:"50%",alignItems:"center"}}
              onChange={e => setCC1Val(e.target.value)}/>
          </td>
        </tr>

</table>
{/* 
<br/>
<br/>

<div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }} // Hide the actual input
        accept="image/*" // Restrict to image files
      />
      <button type="button" className={`blackBodyFontCenterBold`} onClick={handleUploadButtonClick} style={{width:"20%",alignItems:"center",background:'#bbc1c9'}}>
        Attach Photo for use in Club Directory
      </button>
      <br/>
      <label style={{ marginLeft: '10px'}}>Photos will be adjusted to standard size for directory and cropped to head-shots.</label>
      {imageSrc && (
        <div>
          <h4>Preview:</h4>
          <img src={imageSrc} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
        </div>
      )}
    </div> */}


      <br></br>

      <div style={{alignItems:"center"}} >
      <input className={`blackBodyFontCenter`} type="submit" value="Send"  style={{width:"20%",alignItems:"center",background:'#bbc1c9'}} />
      </div>
    </form>
  );
};
export default ContactForm;